import React from "react";
import Fade from "react-reveal/Fade";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import VerificaToken from "../../components/VerificaToken";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import axios from "axios";

function AggiungiPagamento() {
  let history = useHistory();

  const { user, setUser } = VerificaToken();

  const initialValues = {
    nomeIntestatario: "",
    scadenzaCarta: "",
    codiceCarta: "",
    cvc: "",
  };

  const validationSchema = Yup.object().shape({
    nomeIntestatario: Yup.string()
      .required("Devi compilare questo campo!")
      .min(3, "Valore non valido: Troppo corto!")
      .max(20, "Valore non valido: Troppo lungo!"),
    codiceCarta: Yup.string("Devi inserire solamente numeri!")
      .required("Devi compilare questo campo!")
      .min(16, "Valore non valido: Troppo corto!"),
    cvc: Yup.string("Devi inserire solamente numeri!")
      .min(3, "Valore non valido: Troppo corto!")
      .max(3, "Valore non valido: Troppo lungo!")
      .required("Devi compilare questo campo!"),
    scadenzaCarta: Yup.date().required("Devi compilare questo campo!"),
  });

  const onSubmit = (data) => {
    axios
      .put(
        `https://website-8bit-motors.herokuapp.com/account/info/${user.id}/aggiungiPagamento`,
        data
      )
      .then(() => {
        axios
          .get(
            `https://website-8bit-motors.herokuapp.com/account/info/${user.id}`
          )
          .then((res) => {
            setUser(res.data);
            history.push(`/account/info/${user.id}`);
          });
      });
  };

  return (
    <Container fluid>
      {/* SEZIONE BANNER */}
      <Container
        fluid
        id="banner_recovered"
        className="head-banner text-center text-white"
      >
        <Container>
          <Row>
            <Col>
              <h1>
                <strong>8-Bit Motors</strong>
              </h1>
            </Col>
          </Row>
        </Container>
      </Container>

      <Container className="text-center">
        <h2 className="mt-3">Aggiungi Metodo di Pagamento</h2>
        <Formik
          onSubmit={onSubmit}
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          <Form>
            <Row>
              <Col>
                <Fade left>
                  <label
                    className="mb-1 mt-3 form_registrazione"
                    for="nomeIntestatario"
                  >
                    Nome Intestatario
                  </label>
                  <ErrorMessage name="nomeIntestatario" component="h6" />
                  <Field
                    type="text"
                    className="form-control input_registrazione"
                    name="nomeIntestatario"
                    placeholder="Mario Rossi"
                  />
                  <label
                    className="mb-1 mt-3 form_registrazione"
                    for="codiceCarta"
                  >
                    Codice Carta
                  </label>
                  <ErrorMessage name="codiceCarta" component="h6" />
                  <Field
                    type="text"
                    className="form-control input_registrazione"
                    name="codiceCarta"
                    placeholder="Codice Carta"
                  />
                </Fade>
              </Col>
              <Col>
                <Fade right>
                  <label
                    className="mb-1 mt-3 form_registrazione"
                    for="scadenzaCarta"
                  >
                    Scadenza Carta
                  </label>
                  <ErrorMessage name="scadenzaCarta" component="h6" />
                  <Field
                    type="date"
                    className="form-control input_registrazione"
                    name="scadenzaCarta"
                    placeholder="Scadenza Carta"
                  />
                  <label className="mb-1 mt-3 form_registrazione" for="cvc">
                    CVC
                  </label>
                  <ErrorMessage name="cvc" component="h6" />
                  <Field
                    type="text"
                    className="form-control input_registrazione"
                    name="cvc"
                    placeholder="CVC"
                  />
                </Fade>
              </Col>
            </Row>
            <Button type="sumbit" className="mt-4" variant="success">
              Conferma
            </Button>
          </Form>
        </Formik>
      </Container>
      <br />
      <br />
      <br />
    </Container>
  );
}

export default AggiungiPagamento;
